module.exports = __webpack_public_path__ + "img/x-close.81ed8e5e.svg";